import type { UserResponse } from "@/features/auth/types";
import { apiClient } from "@/lib/apiClient";

export const getCurrentUser = async (): Promise<UserResponse> => {
  const user = await apiClient.get<UserResponse>("users/me", { cache: "no-store" });
  if (
    !user ||
    typeof user.id !== "string" ||
    typeof user.username !== "string" ||
    typeof user.organizationId !== "string" ||
    !Array.isArray(user.roles)
  ) {
    throw new Error("Invalid user session response");
  }
  return user;
};
